import { TotalPremium, useTotalPremiumVisibility } from '../../../../components/TotalPremium';
import { useCoveragesPremiums } from '../../useCoveragesForm';

import type { ShopContentCommon, ShopPageEventHandlers } from '../../Shop';

export const PremiumBar: React.FC<ShopContentCommon & ShopPageEventHandlers & { isValid: boolean }> = ({
  country,
  translations,
  eventHandlers,
  isValid = true,
}) => {
  const { premiumVisible, ref } = useTotalPremiumVisibility();
  const scrollToReceipt = () => ref.current?.scrollIntoView({ behavior: 'smooth' });
  const { premium, isLoading } = useCoveragesPremiums();
  const hideTotalPremium = !isValid || premiumVisible;

  return (
    <TotalPremium
      onClick={scrollToReceipt}
      onBack={eventHandlers.onBack}
      total={premium.amount}
      hide={hideTotalPremium}
      isLoading={isLoading}
      country={country}
      content={{
        continue: translations.totalPremiumContinue,
        per_period: translations.perMonth,
      }}
    />
  );
};
